


// NEWS SLIDE

let newsSlider = document.querySelectorAll('.swiperNews')
if(newsSlider)
newsSlider.forEach(slide => {
    if(window.innerWidth <= 640) // SMARTHPHONE
        var swiper = new Swiper(slide, {
            slidesPerView: 1,
            spaceBetween: 10,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    else // PC
        var swiper = new Swiper(slide, {
            slidesPerView: 2,
            autoplay: {
                delay: 5000,
            },
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
            },
        });
});



// SLIDER INITIALIZER
let sliderSection = document.querySelector('section.slider')
console.log(sliderSection)
if(sliderSection) {
    let swiperSliderBanner = new Swiper('.swiper-slider-banner',  sliderSettings );
}
